package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SaveClubSeasonPayload(
    @SerialName("seasonID")
    val seasonId: String,
    val organization: String,
    val name: String,
    val startDate: String,
    val endDate: String,
    val status: String,
)


// Response
@Serializable
data class SaveClubSeasonResponse(
    val data: String? = null,
    val seasonId: String? = null,
    val status: String? = null,
    val error: String? = null,
)
